import React from 'react';
import { useIntl } from 'react-intl';
import CustomBtn from '../../../../../../generic/CustomBtn';
import './CarbonFormTabsButtons.scss';

const CarbonFormTabsButtons = ({ tabs, activeTabId, switchTab, errors, type = false }) => {
  const translate = useIntl();

  return (
    <div className={`tabs-buttons${type ? ' other' : ''}`}>
      {tabs.map((t) => {
        const { data: { label, tabId, tabKey } } = t;
        const extraButtonClass = errors[tabKey] ? 'tab-button_error'
          : activeTabId === tabId ? 'tab-button_active' : '';
        return (
          <div className="tab-button-wrapper" key={`${tabKey}-button`}>
            <CustomBtn
              label={translate.formatMessage({ id: label })}
              handleClick={() => switchTab(t)}
              customClass={`tab-button ${extraButtonClass}`}
              iconClass={errors[tabKey] ? 'icon-exclamation' : ''}
            />
          </div>
        );
      })}
    </div>
  );
};

export default CarbonFormTabsButtons;
